import { supabase, REMEMBER_ME_KEY } from './supabase';

/**
 * Sign up a new user with email and password
 */
export const signUp = async (email, password, metadata = {}) => {
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: {
      data: metadata,
      // After email confirm, land on the welcome guide — not Site URL / billing.
      emailRedirectTo: `${window.location.origin}/demo`,
    },
  });

  if (error) throw error;
  return data;
};

/**
 * Sign in with email and password.
 * @param {boolean} [rememberMe] - If false, session is stored in sessionStorage (logout on tab close). If true or omitted, uses localStorage.
 */
export const signIn = async (email, password, rememberMe = true) => {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(REMEMBER_ME_KEY, rememberMe ? 'true' : 'false');
  }
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });

  if (error) throw error;
  return data;
};

/**
 * Sign out the current user
 */
export const signOut = async () => {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
};

/**
 * Get the current user session
 */
export const getSession = async () => {
  const { data, error } = await supabase.auth.getSession();
  if (error) throw error;
  return data.session;
};

/**
 * Get the current user
 */
export const getCurrentUser = async () => {
  const { data, error } = await supabase.auth.getUser();
  if (error) throw error;
  return data.user;
};

/**
 * Subscribe to auth state changes
 */
export const onAuthStateChange = (callback) => {
  return supabase.auth.onAuthStateChange(callback);
};

/**
 * Send password reset email
 */
export const resetPassword = async (email) => {
  const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
    redirectTo: `${window.location.origin}/reset-password`,
  });

  if (error) throw error;
  return data;
};

/**
 * Exchange a recovery token from the email link for a session.
 * Called only after the user submits the form, so inbox link scanners
 * that merely open the URL do not consume the token.
 */
export const verifyRecoveryToken = async (tokenHash) => {
  const { data, error } = await supabase.auth.verifyOtp({
    token_hash: tokenHash,
    type: 'recovery',
  });

  if (error) throw error;
  return data;
};

/**
 * Update user password
 */
export const updatePassword = async (newPassword) => {
  const { data, error } = await supabase.auth.updateUser({
    password: newPassword,
  });

  if (error) throw error;
  return data;
};

/**
 * Update user profile metadata
 */
export const updateProfile = async (updates) => {
  const { data, error } = await supabase.auth.updateUser({
    data: updates,
  });

  if (error) throw error;
  return data;
};
